import React from "react";
import { useDrag, useDrop } from "react-dnd";
import styled from "styled-components";

const BlockItem = styled.div`
  width: 200px;
  height: 200px;
  background: ${({ backgroundColor = "red" }) => backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  color: white;
  flex-shrink: 0;
  cursor: grab;
`;

export const DraggableBlock = ({ item, index, moveBlock }) => {
  const [, ref] = useDrag({
    type: "BLOCK",
    item: { index },
  });

  const [, drop] = useDrop({
    accept: "BLOCK",
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveBlock(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  // การ render โดยเปลี่ยนแปลงตาม type ของ item

  return (
    <div ref={(node) => ref(drop(node))}>
      {(() => {
        switch (item.type) {
          case "A":
            return <BlockItem>{item.name} - Type A</BlockItem>;
          case "B":
            return (
              <BlockItem backgroundColor="blue">{item.name} - Type B</BlockItem>
            );
          case "C":
            return (
              <BlockItem backgroundColor="green">
                {item.name} - Type C
              </BlockItem>
            );
          default:
            return <BlockItem>{item.name}</BlockItem>;
        }
      })()}
    </div>
  );
};
